import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_FUEL_ID_LOADING = 'GET_FUEL_ID_LOADING';
export const GET_FUEL_ID_SUCCESS = 'GET_FUEL_ID_SUCCESS';
export const GET_FUEL_ID_REJECT = 'GET_FUEL_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getFuelIdLoading = () => ({ type: GET_FUEL_ID_LOADING });
export const getFuelIdSuccess = (payload) => ({ type: GET_FUEL_ID_SUCCESS, payload });
export const getFuelIdReject = (payload) => ({ type: GET_FUEL_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getFuelIdRequest = async ({ id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { id },
    }, getState);
    return request(`/Fuels/web/GetFuelsById`, options);
};